import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { trackPageView } from '../../utils/analytics.js';

// Pathless layout route: renders the matched route via <Outlet /> and fires a
// GA4 page view on every navigation, including the initial load. This is the
// SPA replacement for Next.js's automatic per-route page views.
// trackPageView() is a no-op when GA isn't loaded, so this is safe everywhere.
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return <Outlet />;
};

export default RouteTracker;
